import React from 'react';
import styled from 'styled-components';
import { enqueueSnackbar, closeSnackbar } from 'notistack';
import { Button } from '@mui/material';

// UTILITY
import getErrorMessage from '@/utility/errors';

// LOCALE
import { t } from '@/locale/i18n';

const CloseButton = styled(Button)`
  font-size: 1.2rem;
  line-height: 2rem;
  padding: 1px 5px;

  &:hover {
    background-color: transparent;
  }
`;

const closeAction = key => {
  return (
    <CloseButton color="inherit" variant="text" onClick={() => closeSnackbar(key)}>
      {t('buttons.close')}
    </CloseButton>
  );
};

export const pushNotification = (message, options = {}) => {
  enqueueSnackbar(message, {
    autoHideDuration: 5000,
    ...options,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
    action: closeAction,
  });
};

export const pushSuccessNotification = (message, options = {}) => {
  pushNotification(message, { variant: 'success', ...options });
};

export const pushErrorNotification = (error, options = {}) => {
  pushNotification(getErrorMessage(error), { variant: 'error', ...options });
};

export default { pushNotification, pushSuccessNotification, pushErrorNotification };
